import { i18n } from '@/main'


export const GameList = [
  {
    key: 'Gems of Olympus',
    img: require('@/assets/images/games/GemsofOlympus.png'),
    'img-zh': require('@/assets/images/games/GemsofOlympus-zh.png'),
    textKey:1,
    FolderName: "Slot_GemsOfOlympus",
    alt: i18n.t('seo.game1'),
    altKey: 'seo.game1'
  },
  {
    key: 'Golden Mahjong 2',
    img: require('@/assets/images/games/GoldenMahjong2.png'),
    'img-zh': require('@/assets/images/games/GoldenMahjong2-zh.png'),
    textKey:2,
    FolderName: "Slot_GoldenMahjong2",
    alt: i18n.t('seo.game2'),
    altKey: 'seo.game2'
  },
  {
    key: 'Fire Ball Day of the Dead',
    img: require('@/assets/images/games/FireBallDayoftheDead.png'),
    'img-zh': require('@/assets/images/games/FireBallDayoftheDead-zh.png'),
    textKey:3,
    FolderName: "Slot_DayOfTheDead",
    alt: i18n.t('seo.game3'),
    altKey: 'seo.game3'
  },
  {
    key: 'Golden Miner',
    img: require('@/assets/images/games/GoldenMiner.png'),
    'img-zh': require('@/assets/images/games/GoldenMiner-zh.png'),
    textKey:4,
    alt: i18n.t('seo.game4'),
    altKey: 'seo.game4'
  },
  {
    key: 'Safari World',
    img: require('@/assets/images/games/SafariWorld.png'),
    'img-zh': require('@/assets/images/games/SafariWorld-zh.png'),
    textKey:5,
    alt: i18n.t('seo.game5'),
    altKey: 'seo.game5'
  },
  {
    key: 'Cleopatra’s Treasure',
    img: require('@/assets/images/games/CleopatrasTreasure.png'),
    'img-zh': require('@/assets/images/games/CleopatrasTreasure-zh.png'),
    textKey:6,
    alt: i18n.t('seo.game6'),
    altKey: 'seo.game6'
  },
  {
    key: 'Egyptian Legends',
    img: require('@/assets/images/games/EgyptianLegends.png'),
    'img-zh': require('@/assets/images/games/EgyptianLegends-zh.png'),
    textKey:7,
    alt: i18n.t('seo.game7'),
    altKey: 'seo.game7'
  },
  {
    key: 'Fire Ball Jurassic',
    img: require('@/assets/images/games/FireBallJurassic.png'),
    'img-zh': require('@/assets/images/games/FireBallJurassic-zh.png'),
    textKey:8,
    alt: i18n.t('seo.game8'),
    altKey: 'seo.game8'
  },
  {
    key: 'Hawaii Paradise',
    img: require('@/assets/images/games/HawaiiParadise.png'),
    'img-zh': require('@/assets/images/games/HawaiiParadise-zh.png'),
    textKey:9,
    alt: i18n.t('seo.game9'),
    altKey: 'seo.game9'
  },
  {
    key: 'Speed King',
    img: require('@/assets/images/games/SpeedKing.png'),
    'img-zh': require('@/assets/images/games/SpeedKing-zh.png'),
    textKey:10,
    alt: i18n.t('seo.game10'),
    altKey: 'seo.game10'
  },
  {
    key: 'Fire Ball Gahesha',
    img: require('@/assets/images/games/FireBallGahesha.png'),
    'img-zh': require('@/assets/images/games/FireBallGahesha-zh.png'),
    textKey:11,
    alt: i18n.t('seo.game11'),
    altKey: 'seo.game11'
  },
  {
    key: 'Gladiator',
    img: require('@/assets/images/games/Gladiator.png'),
    'img-zh': require('@/assets/images/games/Gladiator-zh.png'),
    textKey:12,
    alt: i18n.t('seo.game12'),
    altKey: 'seo.game12'
  },
]
